const navigator: Navigator | undefined = globalThis.navigator;

export function detectBrowser(userAgent: string) {
  let browserName = navigator?.appName || '';
  let fullVersion = navigator ? '' + parseFloat(navigator.appVersion) : '';
  let nameOffset: number | undefined;
  let versionOffset: number | undefined;
  let trimIndex;

  // in Opera, the true version comes after "Opera" or after "Version"
  if ((versionOffset = userAgent.indexOf('Opera')) !== -1) {
    browserName = 'Opera';
    fullVersion = userAgent.substring(versionOffset + 6);

    if ((versionOffset = userAgent.indexOf('Version')) !== -1) {
      fullVersion = userAgent.substring(versionOffset + 8);
    }
  }
  // in MSIE, the true version is after "MSIE" in userAgent
  else if ((versionOffset = userAgent.indexOf('MSIE')) !== -1) {
    browserName = 'Microsoft Internet Explorer';
    fullVersion = userAgent.substring(versionOffset + 5);
  }
  // in Chrome, the true version comes after "Chrome"
  else if ((versionOffset = userAgent.indexOf('Chrome')) !== -1) {
    browserName = 'Chrome';
    fullVersion = userAgent.substring(versionOffset + 7);
  }
  // in Safari, the true version comes after "Safari" or after "Version"
  else if ((versionOffset = userAgent.indexOf('Safari')) !== -1) {
    browserName = 'Safari';
    fullVersion = userAgent.substring(versionOffset + 7);

    if ((versionOffset = userAgent.indexOf('Version')) !== -1) {
      fullVersion = userAgent.substring(versionOffset + 8);
    }
  }
  // in Firefox, the true version comes after "Firefox"
  else if ((versionOffset = userAgent.indexOf('Firefox')) !== -1) {
    browserName = 'Firefox';
    fullVersion = userAgent.substring(versionOffset + 8);
  }
  // in most other browsers, "name/version" is at the end of userAgent
  else if ((nameOffset = userAgent.lastIndexOf(' ') + 1) < (versionOffset = userAgent.lastIndexOf('/'))) {
    browserName = userAgent.substring(nameOffset, versionOffset);
    fullVersion = userAgent.substring(versionOffset + 1);

    if (navigator && browserName.toLowerCase() == browserName.toUpperCase()) {
      browserName = navigator.appName;
    }
  }

  // trim the fullVersion string at semicolon/space if present
  if ((trimIndex = fullVersion.indexOf(';')) !== -1) {
    fullVersion = fullVersion.substring(0, trimIndex);
  }

  if ((trimIndex = fullVersion.indexOf(' ')) !== -1) {
    fullVersion = fullVersion.substring(0, trimIndex);
  }

  let majorVersion = parseInt('' + fullVersion, 10);

  if (navigator && isNaN(majorVersion)) {
    fullVersion = '' + parseFloat(navigator.appVersion);
    majorVersion = parseInt(navigator.appVersion, 10);
  }

  return { browserName, fullVersion, majorVersion, userAgent };
}

export function isSafari() {
  return !!navigator && detectBrowser(navigator.userAgent).browserName === 'Safari';
}
